import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InAppMessageApiResponseType } from '../../data-access/models/in-app-message-api-response.type';
import { InAppMessagesApiService } from '../../data-access/services/in-app-messages-api.service';
import { NgxBottomSheetService } from '@digipay/ngx-bottom-sheet';
import { NgxButtonComponent } from '@digipay/ngx-button';

@Component({
  selector: 'common-in-app-messages-in-app-message-dialog',
  standalone: true,
  imports: [CommonModule, NgxButtonComponent],
  templateUrl: './in-app-message-dialog.component.html',
  styleUrl: './in-app-message-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InAppMessageDialogComponent {
  bottomSheetService = inject<NgxBottomSheetService<InAppMessageDialogComponent>>(NgxBottomSheetService);
  inAppMessageService = inject(InAppMessagesApiService);
  messageData = signal<InAppMessageApiResponseType>({} as InAppMessageApiResponseType);
  acceptButtonLabel = signal<string>('خواندم');
  declineButtonLabel = signal<string>('بعدا');

  constructor() {
    this.messageData.set(this.bottomSheetService.data().data);
  }

  handleDeclineClick(): void {
    this.bottomSheetService.closeBottomSheet();
  }

  handleAcceptClick(): void {
    this.inAppMessageService.readMessage(this.messageData().uid).subscribe({
      next: (res) => {
        if (res) {
          this.bottomSheetService.closeBottomSheet();
        }
      },
      error: (err) => {
        console.error(err);
      },
    });
  }
}
